module.exports = __webpack_public_path__ + "gainsight-logo-075a85800252bc0fd504aaad46906b2f.webp";